{
  "name": "my-jobfixers",
  "version": "0.0.0",
  "scripts": {
    "start": "ng serve --open",
    "build:dev": "ng build",
    "build:qa": "ng build -c qa",
    "build:prod": "ng build -c prod",
    "test": "ng test",
    "prepare": "husky"
  },
  "prettier": {
    "useEditorConfig": false,
    "printWidth": 100,
    "singleQuote": true,
    "arrowParens": "avoid",
    "overrides": [
      {
        "files": "*.html",
        "options": {
          "parser": "angular"
        }
      }
    ]
  },
  "private": true,
  "packageManager": "npm@11.4.2",
  "dependencies": {
    "@angular/common": "^21.0.0",
    "@angular/compiler": "^21.0.0",
    "@angular/core": "^21.0.0",
    "@angular/forms": "^21.0.0",
    "@angular/platform-browser": "^21.0.0",
    "@angular/router": "^21.0.0",
    "@googlemaps/js-api-loader": "^1.16.10",
    "@ionic/angular": "^8.7.11",
    "@ngrx/signals": "^21.0.1",
    "@ngx-translate/core": "^17.0.0",
    "@ngx-translate/http-loader": "^17.0.0",
    "@primeuix/themes": "^2.0.2",
    "@sentry/angular": "10.69.0",
    "@sentry/capacitor": "4.4.0",
    "luxon": "^3.7.2",
    "primeng": "^21.0.2",
    "rxjs": "~7.8.0",
    "tailwindcss-primeui": "^0.6.1",
    "tslib": "^2.3.0"
  },
  "devDependencies": {
    "@angular/build": "^21.0.1",
    "@angular/cli": "^21.0.1",
    "@angular/compiler-cli": "^21.0.0",
    "@ionic/angular-toolkit": "latest",
    "@tailwindcss/postcss": "^4.1.12",
    "@types/google.maps": "^3.65.2",
    "@types/luxon": "^3.7.1",
    "husky": "^9.1.7",
    "jsdom": "^27.1.0",
    "postcss": "^8.5.3",
    "prettier": "^3.7.3",
    "tailwindcss": "^4.1.12",
    "typescript": "~5.9.2",
    "vitest": "^4.0.8"
  }
}
